import getCallResult from './CallResult';

// Calls of Session API.

export default class SessionAPI {
    constructor() {
        this.baseUrl = this.getBaseUrl();

        this.deviceType = {
            unknown: 0,
            desktop: 1,
            tablet: 2,
            mobile: 3
        };
    }

    createSession(
        dcsHash,
        identityProviderId,
        participantId,
        userAgent,
        jsVersion,
        assemblyVersion,
        isReviewer,
        sampleProviderId,
        urlParams,
        sessionGuid,
        inclusionMode,
        deviceTypeName,
        customParticipantId
    ) {
        const url = 'session';
        const data = {
            urlHash: dcsHash,
            identityProviderId: identityProviderId,
            sampleProviderId: sampleProviderId,
            participantId: participantId,
            userAgent: userAgent,
            jsVersion: jsVersion,
            assemblyVersion: assemblyVersion,
            isReviewer: isReviewer,
            metadata: urlParams,
            sessionGuid: sessionGuid,
            inclusionMode: inclusionMode,
            deviceType: this.deviceType[deviceTypeName] || this.deviceType.unknown,
            customParticipantId: customParticipantId
        };
        return this.sendRequest(url, 'POST', true, JSON.stringify(data), 40000);
    }

    updateSession(sessionId, data, sync) {
        const url = `session/${sessionId}`;

        return this.sendRequest(url, 'PUT', !sync, JSON.stringify(data));
    }

    /**
     * Set session state
     * @param {any} sessionId
     * @param {any} reasonId
     * @param {any} fromStateId
     * @param {any} toStateId
     * @param {any} clientTime
     * @param {any} reasonMessage
     * @param {any} reasonData
     * @param {any} sync
     * @param {any} data
     *
     * @returns {Promise<object>} a promise to the CallResult
     */
    setState(sessionId, reason, fromStateId, toStateId, clientTime, reasonMessage, reasonData, sync, data) {
        const url = `session/${sessionId}`;

        const requestData = {
            ReasonId: reason?.id,
            FromStateId: fromStateId,
            ToStateId: toStateId,
            ClientTime: clientTime,
            ReasonMessage: reasonMessage,
            ReasonData: reasonData,
            additionalData: data
        };

        return this.sendRequest(url, 'PUT', !sync, JSON.stringify(requestData));
    }

    getTestElementSequences(sessionId) {
        const url = `session/${sessionId}/TestElementSequences`;

        return this.sendRequest(url, 'GET', true, null, 40000);
    }

    saveSessionResults(sessionId, data) {
        data.sessionId = sessionId;
        return this.sendRequest('session/pollresults', 'POST', true, JSON.stringify(data), 60000);
    }

    saveSessionData(sessionId, data) {
        const url = `session/${sessionId}/SaveSessionData`;
        return this.sendRequest(url, 'POST', false, JSON.stringify(data));
    }

    sendRequest(url, method, isAsync, data, timeout) {
        return new Promise((resolve, reject) => {
            const request = new XMLHttpRequest();
            request.onreadystatechange = function () {
                if (request.readyState === 4) {
                    if (request.status === 200) {
                        const data = request.responseText !== '' ? JSON.parse(request.responseText) : null;
                        const result = getCallResult({ data: data, status: request.status });

                        resolve(result);
                    } else {
                        reject();
                    }
                }
            };

            request.open(method, `${this.baseUrl}/${url}`, isAsync);

            if (isAsync) {
                request.timeout = timeout;
            }

            request.setRequestHeader('Content-Type', 'application/json');

            request.send(data);
        });
    }

    getBaseUrl() {
        if (!window.location.origin) {
            window.location.origin =
                window.location.protocol +
                '//' +
                window.location.hostname +
                (window.location.port ? ':' + window.location.port : '');
        }

        //We need for service url the whole current url except urlhash (last section of url)
        const pieces = window.location.pathname.replace(/\/$/, '').split('/');
        const p = pieces.splice(0, pieces.length - 1);
        return p.join('/');
    }
}
